import { gql } from "@apollo/client";

export const QUICK_ACCESS_BY_USER_ID = gql`
  query QuickAccessByUserId($userId: String!) {
    quickAccessByUserId(userId: $userId) {
      userId
      selected
    }
  }
`;

export const UPDATE_QUICK_ACCESS = gql`
  mutation UpdateQuickAccess($input: UpdateQuickAccessInput) {
    updateQuickAccess(input: $input)
  }
`;
